import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const SiteMaps = ({ openModal }) => {
  const [BallroomData, setBallroomData] = useState([]);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const fetchBreadcrumImageData = async () => {
    try {
      const response = await corefetch(
        "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=SMAP"
      );
      if (response && response.length > 0) {
        console.log("fxftyxfyt:", response);
        setBreadcrumList(response);
      } else {
        setBreadcrumList([]);
        console.log("No Breadcrum found");
      }
    } catch (error) {
      console.error("Error fetching Breadcrum List:", error);
      setBreadcrumList([]);
    }
  };

  const fetchBallroomData = async () => {
    try {
      const list = await corefetch("Facility/GetActiveBallroomData");
      if (list && list.length > 0) {
        setBallroomData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchBallroomData();
    fetchBreadcrumImageData();
  }, []);

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h3>SiteMaps</h3>
                <br />
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>SiteMaps</li>
                </ol>
              </div>
            </div>
          </div>{" "}
          {/* end row */}
        </div>{" "}
        {/* end container */}
      </section>

      <section
        className="bg-body-tertiary text-center text-lg-start"
        style={{ marginLeft: "51px" }}
      >
        <div className="container p-3">
          {/* Box with shadow for content */}
          <div className="site-map-box shadow-sm bg-white p-3 rounded">
            <div className="row g-4">
              {/* First Column */}
              <div className="col-md-3 col-6">
                <span>Home</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/home">Home</a>
                  </li>
                </ul>

                <span>About Us</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                </ul>

                <span>Gallery</span>
                <ul className="list-unstyled mb-3">
                  {BallroomData.map((ballroom) => (
                    <li key={ballroom.facilityID}>
                      <a href={`/gallery/${ballroom.facilityID}/BallRoom`}>
                        {ballroom.facilityName}
                      </a>
                    </li>
                  ))}
                </ul>

                <span>Venue</span>
                <ul className="list-unstyled mb-3">
                  {BallroomData.map((ballroom) => (
                    <li key={ballroom.facilityID}>
                      <a href={`/facilityMain/${ballroom.facilityID}`}>
                        {ballroom.facilityName}
                      </a>
                    </li>
                  ))}
                </ul>

                <span>FAQ</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/faq">FAQ</a>
                  </li>
                </ul>
              </div>

              {/* Second Column */}
              <div className="col-md-3 col-6">
                <span>Contact Us</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/contactus">Contact Us</a>
                  </li>
                </ul>

                <span>Inquiry</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="#" onClick={openModal}>
                      Inquiry
                    </a>
                  </li>
                </ul>

                <span>Vendor</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/vendor">Vendor</a>
                  </li>
                </ul>

                <span>Design/Decor</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/design-decor">Design/Decor</a>
                  </li>
                </ul>

                <span>Policies</span>
                <ul className="list-unstyled mb-3">
                  <li>
                    <a href="/privacypolicy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/termsandconditions">Terms & Conditions</a>
                  </li>
                </ul>
              </div>

              {/* Third Column */}
              <div className="col-md-3 col-6">
                <span>Events</span>
                <ul className="list-unstyled mb-3">
                  {[
                    "Quinceanera",
                    "Wedding",
                    "Corporate",
                    "Private Parties",
                    "Birthday",
                    "Baby Shower",
                    "Graduation",
                    "Engagement",
                    "Others",
                  ].map((event, index) => (
                    <li key={index}>
                      <a
                        href={`/${event
                          .trim()
                          .toLowerCase()
                          .replace(/\s+/g, "")}`}
                      >
                        {event}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Fourth Column */}
              <div className="col-md-3 col-6">
                <strong>Blog</strong>
                <ul className="list-unstyled mb-3">
                  {[
                    { name: "Quinceanera", id: 2 },
                    { name: "Wedding", id: 3 },
                    { name: "Corporate", id: 4 },
                    { name: "Private Parties", id: 5 },
                    { name: "Birthday", id: 15 },
                    { name: "Baby Shower", id: 16 },
                    { name: "Graduation", id: 17 },
                    { name: "Engagement", id: 18 },
                    { name: "Others", id: 19 },
                  ].map((event) => (
                    <li key={event.id}>
                      <a href={`/Blogs/${event.id}`}>{event.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
